import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import CaseRow from "@/components/CaseRow";
import { FolderOpen } from "lucide-react";

export function EmptyHistory() {
  return (
    <div className="mt-12 border border-dashed border-zinc-300 rounded-md p-12 text-center" data-testid="empty-history">
      <FolderOpen className="h-8 w-8 text-zinc-300 mx-auto" />
      <p className="mt-3 text-zinc-600">No saved cases yet.</p>
      <p className="text-sm text-zinc-400 mt-1">Finish a workflow and choose “Save to history”.</p>
      <Link to="/workflow"><Button className="mt-5 bg-[#002FA7] hover:bg-[#002687] text-white">Start a case</Button></Link>
    </div>
  );
}

export function CaseList({ cases, openId, detail, loadingDetail, onToggle, onRemove, onDownload }) {
  return (
    <div className="mt-8 space-y-px bg-zinc-200 border border-zinc-200 rounded-md overflow-hidden" data-testid="history-list">
      {cases.map((c) => (
        <CaseRow
          key={c.id}
          caseItem={c}
          open={openId === c.id}
          detail={openId === c.id ? detail : null}
          loadingDetail={loadingDetail}
          onToggle={onToggle}
          onRemove={onRemove}
          onDownload={onDownload}
        />
      ))}
    </div>
  );
}
